<template>
    <div :class="'type-' + data.type ">
        <div class="treeviewdiv">
            <div :class="'nodetext w-100 type-' + data.type ">
                <div class="d-inline-block tree-column mr-3">{{ data.name }} </div>
                <div v-if="data.type === '20'" class="d-inline-block mr-3 tree-column type-badge-group">Skupina</div>
                <div v-else-if="data.type === '17'" class="d-inline-block mr-3 tree-column">
                    {{ types[data.type-1] ? types[data.type-1].label : data.type }}
                    <span v-if="data.fields && data.fields[0]" class="subfield-toggle" @click.stop="toggleSubfields">
                        <i :class="showSubfields ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" style="font-size:10px;margin-left:6px;color:#94a3b8;"></i>
                        <span style="font-size:11px;color:#94a3b8;margin-left:4px;">{{ Object.keys(data.fields[0]).length }} podpolí</span>
                    </span>
                </div>
                <div v-else class="d-inline-block mr-3 tree-column" :title="data.type">{{ types[data.type-1] ? types[data.type-1].label : data.type }}</div>
                <div v-if="data.type !== '20'" class="d-inline-block tree-column">{{data.slug}}</div>
            </div>
            <!-- Podpolia pre multipole (type 17) - rozbaľovacie -->
            <div v-if="data.type === '17' && data.fields && data.fields[0] && showSubfields" class="subfields-panel">
                <table class="subfields-table">
                    <thead><tr><th>Pole</th><th>Typ</th><th>Slug</th></tr></thead>
                    <tbody>
                        <tr v-for="(sf, si) in data.fields[0]" :key="'sf-'+si">
                            <td>{{ sf.title || si }}</td>
                            <td class="sf-type">{{ sf.type ? (types[sf.type-1] ? types[sf.type-1].label : sf.type) : '' }}</td>
                            <td class="sf-slug">{{ sf.slug || si }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
     </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                data: {},
                showSubfields: false,
                types: [
                    {"value" : '1' ,"label" : 'Text'},
                    {"value" : '2' ,"label" : 'Výberovník'},
                    {"value" : '3' ,"label" : 'Obrázok'},
                    {"value" : '4' ,"label" : 'Dlhý text'},
                    {"value" : '5' ,"label" : 'Celé číslo'},
                    {"value" : '6' ,"label" : 'Desatiné číslo'},
                    {"value" : '7' ,"label" : 'Logická hodnota Áno/Nie'},
                    {"value" : '8' ,"label" : 'Priradenie pod typ obsahu'},
                    {"value" : '9' ,"label" : 'Dynamická hodnota'},
                    {"value" : '10' ,"label" : 'Builder'},
                    {"value" : '11' ,"label" : 'Galéria obrázkov'},
                    {"value" : '12' ,"label" : 'Priradenie pod taxonómiu'},
                    {"value" : '13' ,"label" : 'Priradenie pod taxonómiu s násobkom'},
                    {"value" : '14' ,"label" : 'Dátum'},
                    {"value" : '15' ,"label" : 'Multipole - vlastnosti'},
                    {"value" : '16' ,"label" : 'Dátum od - do'},
                    {"value" : '17' ,"label" : 'Multipole'},
                    {"value" : '18' ,"label" : 'Ikona'},
                    {"value" : '19' ,"label" : 'Súbor'},
                    {"value" : '20' ,"label" : 'Skupina'},
                    {"value" : '21' ,"label" : 'Mapa'},
                    {"value" : '22' ,"label" : 'Priradenie konkrétneho obsahu'},
                    {"value" : '22' ,"label" : 'Spätné priradenie obsahu'},
                ],
            };
        },
        methods: {
            onClickButton (data) {
       this.$emit('open', data)
            },
            toggleSubfields() {
                this.showSubfields = !this.showSubfields;
            }
        }
    };

</script>

<style scoped>
.subfield-toggle {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
}
.subfield-toggle:hover {
    opacity: 0.7;
}
.subfields-panel {
    margin-top: 4px;
    width: 100%;
}
.subfields-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    font-weight: 300;
}
.subfields-table th {
    padding: 3px 10px;
    font-size: 10px;
    font-weight: 400;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    text-align: left;
    border-bottom: 1px solid #f1f5f9;
}
.subfields-table td {
    padding: 3px 10px;
    color: #64748b;
    font-weight: 300;
    border-bottom: 1px solid #f8fafc;
}
.sf-type {
    color: #94a3b8;
    font-weight: 300;
}
.sf-slug {
    font-family: monospace;
    font-size: 11px;
    color: #cbd5e1;
    font-weight: 300;
}
.type-badge-group {
    color: #94a3b8;
    font-size: 11px;
    font-weight: 400;
}
</style>
